import { fetchWithConfig } from './apiUtils';

interface Entitlement {
  plan: string;
  features: Record<string, boolean>;
  [key: string]: unknown;
}

export const entitlementsApi = {
  async getMyEntitlement(token: string): Promise<Entitlement> {
    return fetchWithConfig<Entitlement>('/entitlements/my', {
      method: 'GET',
      authToken: token,
    });
  },
};
